import { gql } from "graphql-request";

export const GET_AGENCY_FIRST = gql`
  query GET_AGENCY_FIRST(
    $id: Int
    $userId: Int
    $agencyCode: Int
    $countryCodeId: Int
    $name: String
    $utc: String
    $document: String
    $homeAddress: String
    $emailAddress: String
    $whatsapp: String
    $instagram: String
    $facebook: String
    $typeWithdrawalAgency: TypeWithdrawalAgency
    $typeFilterPoints: TypeFilter
    $pointsInitial: Float
    $pointsFinal: Float
    $typeFilterCoinsForSale: TypeFilter
    $coinsForSaleInitial: Float
    $coinsForSaleFinal: Float
    $typeFilterPointsForTaskHost: TypeFilter
    $pointsForTaskHostInitial: Float
    $pointsForTaskHostFinal: Float
    # $levelAgencyExperience: Float
    $typeFilterComission: TypeFilter
    $comissionInitial: Float
    $comissionFinal: Float
    $isReseller: Boolean
    $isBannerPromotion: Boolean
    $levelAgencyId: Int
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getAgencyFirst(
      id: $id
      userId: $userId
      agencyCode: $agencyCode
      countryCodeId: $countryCodeId
      name: $name
      utc: $utc
      document: $document
      homeAddress: $homeAddress
      emailAddress: $emailAddress
      whatsapp: $whatsapp
      instagram: $instagram
      facebook: $facebook
      typeWithdrawalAgency: $typeWithdrawalAgency
      typeFilterPoints: $typeFilterPoints
      pointsInitial: $pointsInitial
      pointsFinal: $pointsFinal
      typeFilterCoinsForSale: $typeFilterCoinsForSale
      coinsForSaleInitial: $coinsForSaleInitial
      coinsForSaleFinal: $coinsForSaleFinal
      typeFilterPointsForTaskHost: $typeFilterPointsForTaskHost
      pointsForTaskHostInitial: $pointsForTaskHostInitial
      pointsForTaskHostFinal: $pointsForTaskHostFinal
      # levelAgencyExperience: $levelAgencyExperience
      typeFilterComission: $typeFilterComission
      comissionInitial: $comissionInitial
      comissionFinal: $comissionFinal
      isReseller: $isReseller
      isBannerPromotion: $isBannerPromotion
      levelAgencyId: $levelAgencyId
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      status
      error
      data {
        active
        agencyCode
        comission
        coinsForSale
        countryCode {
          id
          name
        }
        countryCodeId
        createdAt
        dateLastActive
        dateLastDelete
        deleted
        document
        emailAddress
        facebook
        homeAddress
        id
        imgAgency
        imgPersonalDocumentBack
        imgPersonalDocumentFront
        personalDocument
        companyDocument
        imgCompanyDocument
        imgSelfieWithDocumentBack
        imgSelfieWithDocumentFront
        instagram
        isBannerPromotion
        isReseller
        levelAgency {
          id
          gradientColor
        }
        # levelAgencyExperience
        levelAgencyId
        name
        legalResponsible
        legalResponsibleEmail
        points
        pointsForTaskHost
        pointsRisk
        typeWithdrawalAgency
        updatedAt
        user {
          id
          username
        }
        userId
        utc
        whatsapp
      }
    }
  }
`;
